// src/hooks/usePageTracking.js
// Automatically tracks page views on every route change

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

const PAGE_TITLES = {
  "/":            "Home",
  "/products":    "Products",
  "/cart":        "Cart",
  "/checkout":    "Checkout",
  "/about":       "About Us",
  "/login":       "Login",
  "/profile":     "My Account",
};

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get title — for dynamic routes like /products/5 use a pattern
    if (location.pathname.startsWith("/admin")) return;

    let title = PAGE_TITLES[location.pathname];
    if (!title) {
      if (location.pathname.startsWith("/products/")) title = "Product Details";
      else title = document.title || "SJ Aroma Candles";
    }
    trackPageView(location.pathname + location.search, title);
  }, [location]);
};

export default usePageTracking;